/* __next_internal_client_entry_do_not_use__ NextStep auto */ import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../btn.module.scss";
import { useStore } from "../StoreProvider";
import { BottomBox } from "./BottomBox";
import BigNumber from "bignumber.js";
const NextStep = (param)=>{
    let { className, onSubmit } = param;
    const t = useTranslations();
    const { timeType, amountValue, accountData } = useStore();
    // 选择质押池子
    const passTimeType = useMemo(()=>timeType !== undefined, [
        timeType
    ]);
    // 输入质押数量
    const passAmountValue = useMemo(()=>BigNumber(amountValue).gt(0), [
        amountValue
    ]);
    // 钱包比质押数要多
    const passUserTokenAmount = useMemo(()=>BigNumber(accountData.userTokenAmount).isGreaterThanOrEqualTo(amountValue), [
        accountData,
        amountValue
    ]);
    // 通过
    const pass = useMemo(()=>{
        return passTimeType && passAmountValue && passUserTokenAmount;
    }, [
        passTimeType,
        passAmountValue,
        passUserTokenAmount
    ]);
    const handleNo = useCallback(()=>{}, []);
    const handleNext = useCallback(()=>{
        pass ? onSubmit() : handleNo();
    }, [
        pass,
        onSubmit,
        handleNo
    ]);
    return /*#__PURE__*/ _jsx(BottomBox, {
        className: className,
        children: /*#__PURE__*/ _jsx("div", {
            className: "".concat(styles.bigBtn, " ").concat(pass ? styles.wBtn : styles.banBtn, " max-w-520px ma"),
            onClick: handleNext,
            children: t("nextStep")
        })
    });
};
export { NextStep };
